/**
 * naming-mix lint rule — flags entities that mix camelCase and snake_case
 * field names. Convention violations make the schema harder to scan and
 * suggest a copy-paste from a different domain's convention.
 */
import type { AtlasManifest } from '../types.js';

export interface NamingFinding {
  ref: string;
  message: string;
}

/** True for a field name that contains an underscore (snake_case-ish). */
function isSnakeCase(name: string): boolean {
  return name.includes('_');
}

/** True for a strict camelCase field name (starts lower, has internal upper). */
function isCamelCase(name: string): boolean {
  return /^[a-z][a-z0-9]*[A-Z]/.test(name);
}

export function namingMix(manifest: AtlasManifest): NamingFinding[] {
  const findings: NamingFinding[] = [];
  for (const entity of manifest.entities) {
    let snake = 0;
    let camel = 0;
    for (const f of entity.fields) {
      if (isSnakeCase(f.name)) snake++;
      else if (isCamelCase(f.name)) camel++;
    }
    if (snake > 0 && camel > 0) {
      findings.push({
        ref: entity.id,
        message: `${entity.id} mixes snake_case (${snake}) and camelCase (${camel}) field names — pick one convention`,
      });
    }
  }
  return findings;
}
